(function () {
  function start() {
    var drawer = document.getElementById('drawer');
    var scrim = document.getElementById('drawerScrim');
    var opener = document.getElementById('menuOpen');
    var closer = document.getElementById('menuClose');
    if (!drawer || !opener) return;

    function setOpen(open) {
      drawer.classList.toggle('open', open);
      if (scrim) scrim.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert', '');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    // Initialize closed-drawer inert state
    if (!drawer.classList.contains('open')) drawer.setAttribute('inert', '');

    opener.addEventListener('click', function () { setOpen(true); });
    if (closer) closer.addEventListener('click', function () { setOpen(false); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
